import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import TalentRequestPage from "@/pages/TalentRequestPage";

export const Route = createFileRoute("/talent-request")({
  head: () => pageHead("Request AI Talent | Enterprise Team Augmentation", "Request elite AI engineers, ML specialists, and data scientists for your enterprise projects. Staff augmentation, project teams, and expert advisory services.", "/talent-request", false),
  component: TalentRequestPage,
});
